module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('dir', {
    staticClass: "formBody"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, _vm._l((_vm.fieldSpec), function(fieldMeta, index) {
    return _c('div', {
      key: index,
      staticClass: "form-control-wrapper"
    }, [_c('FormControl', {
      attrs: {
        "control-type": _vm.modelAdapter.field2ControlType(fieldMeta),
        "control-label": fieldMeta['verbose_name'],
        "is-required": fieldMeta['required'],
        "place-holder-text": '请输入' + fieldMeta['verbose_name'],
        "select-range": _vm.fieldData[_vm.modelAdapter.fieldOptionName(fieldMeta)],
        "custom-item": "未选择",
        "readonly": _vm.readonly
      },
      model: {
        value: (_vm.fieldData[fieldMeta['field_name']]),
        callback: function($$v) {
          _vm.$set(_vm.fieldData, fieldMeta['field_name'], $$v)
        },
        expression: "fieldData[fieldMeta['field_name']]"
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "actionView"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_c('span')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [(_vm.readonly) ? _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.goUpdate()
      }
    }
  }, [_vm._v("修改")]) : _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.submitData()
      }
    }
  }, [_vm._v("保存")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0386204b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ModelManagerPage.vue
// module id = 363
// module chunks = 1